import { Link } from "gatsby"
import React from "react"

import {
  Login_InternalLink,
  Logout_InternalLink,
  MyDashboard_InternalLink,
  Profile_InternalLink,
  QuestionPromptList_InternalLink,
  SelfAssessment_InternalLink,
  Signup_InternalLink,
} from "../../utils/urls"
import OnlyForGuest from "../registration/OnlyForGuest"
import OnlyForUser from "../registration/OnlyForUser"
import { registrationButtonWrapper_FuncType } from "../types"

export const CreateProtectedOnlyForUserButton = (
  ButtonElement: object,
  link: string,
  fallBackLink = Login_InternalLink
) => {
  return ({ noUserProfile = false }) => {
    return (
      <OnlyForUser
        redirectTo={null}
        functionalChildren={isUser => {
          return (
            <Link
              to={
                isUser
                  ? noUserProfile
                    ? Profile_InternalLink
                    : link
                  : fallBackLink
              }
            >
              {ButtonElement}
            </Link>
          )
        }}
      />
    )
  }
}

export const QPLButtonWrapper: registrationButtonWrapper_FuncType = (
  ButtonElement: object
) =>
  CreateProtectedOnlyForUserButton(
    ButtonElement,
    QuestionPromptList_InternalLink,
    Login_InternalLink
  )

export const SelfAssessmentWrapper: registrationButtonWrapper_FuncType = (
  ButtonElement: object
) =>
  CreateProtectedOnlyForUserButton(
    ButtonElement,
    SelfAssessment_InternalLink,
    Login_InternalLink
  )

export const MyDashboardButtonWrapper: registrationButtonWrapper_FuncType = (
  ButtonElement: object
) =>
  CreateProtectedOnlyForUserButton(
    ButtonElement,
    MyDashboard_InternalLink,
    Login_InternalLink
  )

export const SignUpButtonWrapper: registrationButtonWrapper_FuncType = (
  ButtonElement: object
) => {
  return () => {
    return (
      <OnlyForGuest redirectTo={null}>
        <Link to={Signup_InternalLink} title="Sign up">
          {ButtonElement}
        </Link>
      </OnlyForGuest>
    )
  }
}

export const LoginButtonWrapper: registrationButtonWrapper_FuncType = (
  ButtonElement: object
) => {
  return () => {
    return (
      <OnlyForGuest redirectTo={null}>
        <Link to={Login_InternalLink} title="Log in">
          {ButtonElement}
        </Link>
      </OnlyForGuest>
    )
  }
}

export const LogoutButtonWrapper: registrationButtonWrapper_FuncType = (
  ButtonElement: object
) => {
  return () => {
    return (
      <OnlyForUser redirectTo={null}>
        <Link to={Logout_InternalLink} title="Log out">
          {ButtonElement}
        </Link>
      </OnlyForUser>
    )
  }
}

export const ProfileButtonWrapper: registrationButtonWrapper_FuncType = (
  ButtonElement: object
) => {
  return () => {
    return (
      <OnlyForUser redirectTo={null}>
        <Link to={Profile_InternalLink} title="My profile">
          {ButtonElement}
        </Link>
      </OnlyForUser>
    )
  }
}
